import React, { useState } from 'react';
import { motion } from "framer-motion";
import { media } from "../resources/utils";

import styles from './Media.module.scss';

const variants = {
  waiting: {
    y: 10,
    opacity: 0
  },
  loaded: {
    y: 0,
    opacity: 1
  },
};

const Media = ({ image, noMedia = false }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div data-image-wrapper>
      <motion.img
      variants={variants}
      animate={loaded ? 'loaded' : 'waiting'}
      initial={false}
      onLoad={() => { setLoaded(true); }}
      src={noMedia ? image : media(image)}
      className={styles.image}
      transition={{
        x: { type: "spring", stiffness: 300, damping: 30 },
        opacity: { duration: 0.2 }
      }}
      />
    </div>
  )
}

export default Media;
